import { isNil } from "lodash-es";

export const insertBetween = <T>(array: T[], separator: T): T[] =>
  array.flatMap((item, index) => (index < array.length - 1 ? [item, separator] : [item]));

export const findOrThrow = <T>(arr: T[], predicate: (item: T) => boolean): T => {
  const found = arr.find(predicate);
  if (isNil(found)) {
    throw new Error("Item not found");
  }
  return found;
};
